import { LoadablePaint } from '@confluence/loadable';

export const RecommendedSpaceBannerLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecommendedSpaceBanner" */ '../src/RecommendedSpaceBanner.tsx'
			)
		).RecommendedSpaceBanner,
});
